import type { IAttendanceConfirmation } from "~/utils/interfaces/attendance-review-interfaces";

/** French plural mark, empty below two. */
function s(count: number): string {
  return count > 1 ? "s" : "";
}

/**
 * What the run wrote, one line per thing that happened — so a run with nothing special to say
 * stays a single line. Read after the confirm call, from the counts the API answered with.
 */
export function attendanceConfirmationLines(confirmation: IAttendanceConfirmation | null): string[] {
  if (!confirmation) return [];

  const { declaredCount, addedNames, absentNames } = confirmation;
  const lines = [`${declaredCount} présence${s(declaredCount)} enregistrée${s(declaredCount)}.`];

  if (addedNames.length) {
    lines.push(
      `${addedNames.length} participant${s(addedNames.length)} ajouté${s(addedNames.length)} à la session : ${addedNames.join(", ")}.`,
    );
  }
  if (absentNames.length) {
    lines.push(
      `${absentNames.length} participant${s(absentNames.length)} marqué${s(absentNames.length)} absent${s(absentNames.length)} : ${absentNames.join(", ")}.`,
    );
  }

  return lines;
}
